var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.translation).length > 0)?_c('div',{staticClass:"Background",class:{
        'Background--desktop': !_vm.isMobile,
        'Background--mobile': _vm.isMobile,
        'Background--home': _vm.$route.path === '/',
        'Background--assessment': _vm.$route.path === '/vessel-specific-assessment',
        'Background--results' : _vm.$route.path === '/calculate_results' || _vm.$route.path === '/find_results'
}},[_c('hempel-header'),_c('div',{staticClass:"ContentWrapper",class:{
            'ContentWrapper--results': !_vm.isMobile && (_vm.$route.path === '/calculate_results' || _vm.$route.path === '/find_results'),
            'ContentWrapper--assessment': _vm.$route.path === '/vessel-specific-assessment'
        }},[_c('router-view',{staticClass:"RouteView",class:{
                'RouteView--results': !_vm.isMobile && (_vm.$route.path === '/calculate_results' || _vm.$route.path === '/find_results'),
                'RouteView--assessment': _vm.$route.path === '/vessel-specific-assessment'
            }}),_c('hempel-footer'),_c('hempel-overlay',{attrs:{"recommendation":_vm.recommendation,"feedback":_vm.feedback}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }